document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.today__wrapper').forEach(wrapper => {
        // console.log(scrolledP)
        const arrowNext = wrapper.querySelector('.today__arrow')
        const arrowPrev = wrapper.querySelector('.today__arrow-back')
        const list = wrapper.querySelector('.today__list')
        console.log(arrowNext)
        console.log(arrowPrev)
        console.log(list)

        // if (todayArrowNodesP.length > 0) {
        // Check if the main elements actually exist before continuing
        if (!arrowNext || !arrowPrev || !list) return;

            let scrolledP = 0

            arrowNext.addEventListener('click', () => {
                console.log('clicked next')
                if (list.offsetWidth < list.scrollWidth) {
                    scrolledP += list.offsetWidth;
                }
                list.scroll({ left: scrolledP, behavior: 'smooth' });

                if (scrolledP + list.offsetWidth >= list.scrollWidth) {
                    arrowNext.classList.add('end');
                }
                if (scrolledP !== 0) {
                    arrowPrev.classList.remove('end');
                }
            });

            arrowPrev.addEventListener('click', () => {
                console.log('clicked prev')
                if (scrolledP > 0) {
                    scrolledP -= list.offsetWidth;
                }
                list.scroll({ left: scrolledP, behavior: 'smooth' });

                if (scrolledP === 0) {
                    arrowPrev.classList.add('end');
                }
                arrowNext.classList.remove('end');
            });

            // Keyboard support (required and awesome!)
            arrowNext.addEventListener('keyup', e => { if (e.key === 'ArrowRight' || e.key === 'Enter') arrowNext.click(); });
            arrowPrev.addEventListener('keyup', e => { if (e.key === 'ArrowLeft'  || e.key === 'Enter') arrowPrev.click(); });

        // const todayArrowNodesP = Array.from(todayArrowNodesP)
            // const todayBackNodesP = Array.from(todayBackNodesP)
            // const todayNodes = Array.from(todayNodes)

            // [todayArrowNodesP].map((arrow, key) => {
            //     arrow.addEventListener('click', () => {
            //
            //         // console.log('scrolledP: ' + scrolledP)
            //         // console.log('offsetWidth ' + todayNodes[key].offsetWidth)
            //         // console.log('scrollWidth ' + todayNodes[key].scrollWidth)
            //         if (todayNodes[key].offsetWidth < todayNodes[key].scrollWidth) {
            //             scrolledP += todayNodes[key].offsetWidth
            //         }
            //
            //         todayNodes[key].scroll({
            //             top: 0,
            //             left: scrolledP,
            //             behavior: 'smooth'
            //         })
            //
            //         // console.log('scrolledP: ' + scrolledP)
            //         // console.log('offsetWidth ' + todayNodes[key].offsetWidth)
            //         // console.log('scrollWidth ' + todayNodes[key].scrollWidth)
            //         if (scrolledP + todayNodes[key].offsetWidth >= todayNodes[key].scrollWidth) {
            //             arrow.classList.add('end')
            //         }
            //         // console.log(scrolledP != 0)
            //         if (scrolledP != 0) {
            //             todayBackNodesP[key].classList.remove('end')
            //         }
            //     })
            //
            //     arrow.addEventListener('keyup', (e) => {
            //         e = e || window.KeyboardEvent
            //         if (e.key === 'ArrowRight') {
            //             if (todayNodes[key].offsetWidth < todayNodes[key].scrollWidth) {
            //                 scrolledP += todayNodes[key].offsetWidth
            //             }
            //
            //             todayNodes[key].scroll({
            //                 top: 0,
            //                 left: scrolledP,
            //                 behavior: 'smooth'
            //             })
            //             if (scrolledP + todayNodes[key].offsetWidth >= todayNodes[key].scrollWidth) {
            //                 arrow.classList.add('end')
            //             }
            //             if (scrolledP != 0) {
            //                 todayBackNodesP[key].classList.remove('end')
            //             }
            //         }
            //     })
            // })
            //
            // [todayBackNodesP].map((arrow, key) => {
            //     arrow.addEventListener('click', () => {
            //         console.log(scrolledP)
            //         console.log(todayNodes[key].offsetWidth)
            //         if (scrolledP > 0) {
            //             scrolledP -= todayNodes[key].offsetWidth
            //         }
            //
            //         todayNodes[key].scroll({
            //             top: 0,
            //             left: scrolledP,
            //             behavior: 'smooth'
            //         })
            //
            //         if (scrolledP == 0) {
            //             arrow.classList.add('end')
            //         }
            //         todayArrowNodesP[key].classList.remove('end')
            //     })
            //
            //     arrow.addEventListener('keyup', (e) => {
            //         e = e || window.KeyboardEvent
            //         console.log(e.key)
            //         if (e.key === 'ArrowLeft') {
            //             if (scrolledP > 0) {
            //                 scrolledP -= todayNodes[key].offsetWidth
            //             }
            //
            //             todayNodes[key].scroll({
            //                 top: 0,
            //                 left: scrolledP,
            //                 behavior: 'smooth'
            //             })
            //
            //             if (scrolledP == 0) {
            //                 arrow.classList.add('end')
            //             }
            //             todayArrowNodesP[key].classList.remove('end')
            //         }
            //     })
            // })
        // }
    })
})
